import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { I18nState } from "./types";
import { Language, LANGUAGE_KEY } from "./types";

const initialLang = localStorage.getItem(LANGUAGE_KEY) || Language.RU;
const initialState: I18nState = {
  selectedLang: initialLang as Language,
};

export const i18nSlice = createSlice({
  initialState,
  name: "i18n",
  reducers: {
    setSelectedLang: (state: I18nState, action: PayloadAction<Language>) => {
      state.selectedLang = action.payload;
    },
  },
});

export const i18nReducer = i18nSlice.reducer;
export const { setSelectedLang } = i18nSlice.actions;
